import { IGetState, TCardId } from 'app/types/types';
import { Dispatch, ThunkAction } from 'app/types/actions';
import { selectFiles } from '../effects/selectFiles';
import { IDriveDoc } from 'app/store/model/card/types/IDriveDoc';
import { SegmentCardEvent, SegmentCardOptions, segmentTrackAction } from '../../../../../../../../middlewares/segment';
import {
    setAttachmentAddedSessionStorage
} from '../../../../../../aside_panel/cardDetails/AttachmentsSection/helpers/setAttachmentAddedSessionStorage';
import { SegmentCardSourceValue } from '../../../../../../../../middlewares/segment/trackEntities/cardEvents';
import { getIsChatViewActive } from '../../../../../../../../store/router/selectors/getIsChatViewActive';

export const onSelectClick = (
    cardId: TCardId,
    onClose: () => void,
    setAttachments: (docs: IDriveDoc[]) => void,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        dispatch(segmentTrackAction(SegmentCardEvent.COMMENT_ATTACHMENT_ADD_CLICKED, {
            name: SegmentCardOptions.SOURCE,
            value: getIsChatViewActive(getState()) ? SegmentCardSourceValue.CHAT : SegmentCardSourceValue.CARD,
        }));

        return dispatch(selectFiles(cardId))
            .then((driveDocs: IDriveDoc[]) => {
                setAttachmentAddedSessionStorage();
                if (onClose) onClose();
                setAttachments(driveDocs);
                return driveDocs;
            });
    };
    return action;
};
